<title>{{ iagPortalHowDoesItWorkPage.htmlTitle }}</title>
<div class="container">
  <div *ngFor="let section of iagPortalHowDoesItWorkPage.howDoesItWorkSectionOne" class="mt-3">
    <h4>
      {{ section.title }}
    </h4>
    <div class="mt-4">
      <app-note [noteSections]="iagPortalHowDoesItWorkPage.noteSection"> </app-note>
    </div>

    <div [innerHTML]="section.body | mdToHtml" class="mt-4 mb-5"></div>
  </div>

  <app-affected-api-flow-section [sections]="iagPortalHowDoesItWorkPage.apiFlowHowDoestItWorkSection"> </app-affected-api-flow-section>
  <div>
    <div [innerHTML]="iagPortalHowDoesItWorkPage.bodyAboveAirShoopingRq[0] | mdToHtml"></div>
    <div *ngFor="let xml of iagPortalHowDoesItWorkPage.accordianAirShoppingRQ; let i = index">
      <div (click)="toggleCollapsed(xml.order)" class="d-flex mb-0">
        <div [ngClass]="getArrowIcons(xml.order)" class="arrow-icon me-3"></div>
        <div [ngClass]="getActiveStyle(xml.order)"><i class="fas fa-battery-quarter p-1"></i>{{ xml.title }}</div>
      </div>
      <div [ngClass]="getAccordionStyle(xml.order)" class="mrg-top">
        <app-iag-portal-details-xml-section [iagPortalDetailsXmlSection]="iagPortalHowDoesItWorkPage.accordianAirShoppingRQ"> </app-iag-portal-details-xml-section>
      </div>
    </div>
    <div [innerHTML]="iagPortalHowDoesItWorkPage.bodyBelowAirShoopingRq[0] | mdToHtml" class="mt-4"></div>
  </div>

  <div *ngFor="let xml of iagPortalHowDoesItWorkPage.accordianOfferPriceRS; let i = index">
    <div (click)="toggleCollapsed(xml.order)" class="d-flex mb-0">
      <div [ngClass]="getArrowIcons(xml.order)" class="arrow-icon me-3"></div>
      <div [ngClass]="getActiveStyle(xml.order)"><i class="fas fa-battery-half p-1"></i>{{ xml.title }}</div>
    </div>
    <div [ngClass]="getAccordionStyle(xml.order)" class="mrg-top">
      <app-iag-portal-details-xml-section [iagPortalDetailsXmlSection]="iagPortalHowDoesItWorkPage.accordianAirShoppingRQ"> </app-iag-portal-details-xml-section>
    </div>
    <div [innerHTML]="xml.body | mdToHtml" class="mt-4"></div>
  </div>

  <div *ngFor="let image of iagPortalHowDoesItWorkPage.assetImages">
    <div (click)="toggleCollapsed(image.order!)" class="d-flex mb-3">
      <div [ngClass]="getArrowIcons(image.order!)" class="arrow-icon me-3"></div>
      <div [ngClass]="getActiveStyle(image.order!)"><i class="fas fa-battery-full p-1 mb-1"></i>{{ image.title }}</div>
    </div>
    <div [ngClass]="getAccordionStyle(image.order!)" class="mt-4 mb-4">
      <img src="{{ image.image }}" alt="" width="100%" />
    </div>
    <div [innerHTML]="image.description"></div>
  </div>
</div>
